"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function AndroidMulticolorFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M1.115 12.572a1.215 1.215 0 000 2.42.9.9 0 00.74-.346v.15a.155.155 0 00.15.15h.365v-2.32h-.5v.296a.9.9 0 00-.74-.35h-.015zm.095.475a.75.75 0 110 1.5.704.704 0 01-.685-.74.69.69 0 01.685-.76zM3.09 14.947a.145.145 0 01-.145-.15v-2.17h.5v.284a.82.82 0 01.7-.34.87.87 0 01.885.89v1.5h-.36a.16.16 0 01-.16-.16v-1.225a.5.5 0 00-.5-.53.63.63 0 00-.58.67v1.23h-.34zM6.555 12.572a1.215 1.215 0 000 2.42.884.884 0 00.735-.346v.15a.16.16 0 00.15.15h.37v-3.5h-.5v1.456a.885.885 0 00-.735-.35l-.02.02zm.09.475a.75.75 0 010 1.5.7.7 0 01-.68-.74.69.69 0 01.68-.76zM8.53 14.947a.147.147 0 01-.108-.043.145.145 0 01-.042-.107v-2.17h.5v.38a.64.64 0 01.625-.41c.062-.005.123-.005.185 0v.535a.852.852 0 00-.25-.04.611.611 0 00-.56.665v1.17l-.35.02zM12.855 14.947a.145.145 0 01-.15-.15v-2.17h.5v2.32h-.35zM14.745 12.572a1.215 1.215 0 000 2.42.884.884 0 00.755-.346v.15a.16.16 0 00.15.15H16v-3.5h-.5v1.456a.895.895 0 00-.735-.35l-.02.02zm.09.475a.75.75 0 010 1.5.7.7 0 01-.68-.74.692.692 0 01.68-.76zM12.96 12.127a.345.345 0 100-.69.345.345 0 000 .69zM11.075 12.572a1.195 1.195 0 00-1.21 1.21 1.185 1.185 0 001.21 1.225 1.21 1.21 0 100-2.42v-.015zm0 .5a.73.73 0 11-.69.735.699.699 0 01.69-.736z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#32DE84",
    d: "M11.905 3.722l1.325-2.295a.27.27 0 10-.465-.27l-1.34 2.35a8.43 8.43 0 00-6.84 0L3.24 1.157a.27.27 0 10-.465.27L4.1 3.722A7.92 7.92 0 000 10.007h16a7.924 7.924 0 00-4.095-6.285zm-7.575 4a.67.67 0 11.67-.65.67.67 0 01-.67.67v-.02zm7.34 0a.67.67 0 11.67-.67.67.67 0 01-.67.69v-.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.34 7.071a.67.67 0 11-1.34 0 .67.67 0 011.34 0zM5 7.071a.67.67 0 11-1.34 0 .67.67 0 011.34 0z"
  }));
}

AndroidMulticolorFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
AndroidMulticolorFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = AndroidMulticolorFilled;
exports["default"] = _default;